/* eslint-disable no-unused-expressions */
/* eslint-disable no-console */
import { code, db } from 'codemash';
import { Config } from 'configs';
import { apiActionChooser } from 'utils/apiActionChooser';
import { getErrorMessage, manageFunctionResponse } from 'utils/errorHandler';
import { functionRequest, resourceRequest } from './client/requests';

export const getCompanyInfo = async ({ token, useV2, user, alertController }) => {
  try {
    let responseArray;

    if (useV2) {
      responseArray = await resourceRequest({
        data: { id: 'AdminGetCompanyInfo' },
        action: 'aggregate',
      });
    } else {
      responseArray = await db.executeAggregate({
        secretKey: token,
        database: Config.CODEMASH.DATABASE_ID,
        id: 'c3b35ceb-8ed7-421d-a4d1-e18b6076cd46',
        collectionName: Config.DATA.COLLECTIONS.WEB_USERS,
        tokens: { userId: user },
      });
    }

    const response = responseArray && responseArray.length > 0 ? responseArray[0] : null;

    return {
      _id: response?._id,
      user: response?.user,
      display_name: response?.company?.name,
      company: response?.company?._id,
      onboarding_completed: response?.company?.onboarding_completed || false,
      payment_link: response?.billing?.payment_link || null,
    };
  } catch (e) {
    Config.SHOW_LOGS && console.log('Error occured', e);

    if (alertController) {
      alertController.error(getErrorMessage(e));
    }
  }

  return null;
};

export const exportListData = async ({ token, resource, filter, alertController }) => {
  try {
    const response = await code.executeFunction({
      secretKey: token,
      functionId: Config.DATA.FUNCTIONS.EXPORT_CSV,
      data: {
        token,
        resource,
        filter,
      },
    });

    const managedResponse = manageFunctionResponse({
      response,
      alertController,
    });

    if (managedResponse.isError) {
      if (!managedResponse.handled) {
        if (alertController) {
          alertController.error({ text: 'Could not export data' });
        }
      }
    } else {
      return managedResponse;
    }

    return null;
  } catch (e) {
    Config.SHOW_LOGS && console.log('Error while trying to export data', e);

    if (alertController) {
      alertController.error({ text: 'Could not export data' });
    }
  }

  return null;
};

export const downloadCompanyInvoice = async ({ token, companyId, invoiceId, alertController }) => {
  try {
    let response;

    await apiActionChooser(
      companyId,
      async () => {
        response = await code.executeFunction({
          secretKey: token,
          functionId: '68609d50-10d7-4e4b-852f-7f9f1550b0b7',
          data: {
            token,
            invoiceId,
          },
        });
      },
      async () => {
        response = await functionRequest({
          functionName: 'DownloadInvoice',
          data: JSON.stringify({ invoiceId }),
        });
      },
    );

    const managedResponse = manageFunctionResponse({
      response,
      alertController,
    });

    if (managedResponse.isError) {
      if (!managedResponse.handled) {
        if (alertController) {
          alertController.error({ text: 'Could not download invoice' });
        }
      }
    } else {
      return managedResponse;
    }

    return null;
  } catch (e) {
    Config.SHOW_LOGS && console.log('Error while trying to download invoice', e);

    if (alertController) {
      alertController.error({ text: 'Could not download invoice' });
    }
  }

  return null;
};

export const updateWebPushDevice = async ({
  token,
  deviceId,
  enabled,
  enabledOptions,
  alertController,
  companyId,
}) => {
  try {
    let response;

    await apiActionChooser(
      companyId,
      async () => {
        response = await code.executeFunction({
          functionId: '28271ed7-19ad-493f-a3ef-55bab69d3d4f',
          data: {
            token,
            deviceId,
            enabled,
            enabledOptions,
          },
        });
      },
      async () => {
        response = await functionRequest({
          functionName: 'UpdateAdminWebNotifications',
          data: JSON.stringify({
            deviceId,
            enabled,
            enabledOptions,
          }),
        });
      },
    );

    const managedResponse = manageFunctionResponse({
      response,
      alertController,
    });

    if (managedResponse.isError) {
      if (!managedResponse.handled) {
        if (alertController) {
          alertController.error({ text: 'Could not update notification options' });
        }
      }
    } else {
      return managedResponse;
    }

    return null;
  } catch (e) {
    Config.SHOW_LOGS && console.log('Error while trying to update notification options', e);

    if (alertController) {
      alertController.error({ text: 'Could not update notification options' });
    }
  }

  return null;
};
